<template>
    <div class="dashboard">
        <div class="row">
            <div class="col-md-12 text-right">
                <button class="btn btn-primary mb-10" @click="refreshPageData()">
                    <i class="fa fa-refresh" aria-hidden="true"></i> Clear cache and refresh page data
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <soon-sold-out :pageData="pageData" />
            </div>
            <div class="col-md-6">
                <availability-overrides :pageData="pageData" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-7">
                <next-to-order :pageData="pageData" />
            </div>
             <div class="col-md-5">
                <fabric-deliveries :pageData="pageData" />
            </div>
        </div>
        <div class="loading" v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i>
        </div>
    </div>
</template>

<script>
import PopularFabric from './dashboardComponents/PopularFabric';
import NextToOrder from './dashboardComponents/NextToOrder';
import FabricSaleGraph from './dashboardComponents/FabricSaleGraph';
import FabricInventory from './dashboardComponents/FabricInventory';
import FabricDeliveries from './dashboardComponents/FabricDeliveries';
import SoonSoldOut from './dashboardComponents/SoonSoldOut';
import AvailabilityOverrides from './dashboardComponents/AvailabilityOverrides';
export default {

    components: {
    PopularFabric,
    NextToOrder,
    FabricSaleGraph,
    FabricInventory,
    FabricDeliveries,
    SoonSoldOut,
    AvailabilityOverrides
},

    data() {
        return {
            loading: true,
            pageData: {},
            serverParams: {
                inventory: {
                    fabricId : null,
                    lastXMonths : 1
                },
                saleGraph: {
                    lastXMonths : 1
                },
                refreshData: 0
            },
            allFabrics: []
        }
    },

    mounted() {
        this.getFabrics();
    },

    methods: {
        serverParamsChanged() {
            this.getPageData();
        },

        refreshPageData() {
            this.serverParams.refreshData = 1;
            this.getPageData();
        },

        async getFabrics () {
            let response = await axios.get('/v2/fabrics?as_dropdown=1');
            this.allFabrics = response.data.data.collection;
            this.serverParams.inventory.fabricId = this.allFabrics[0].id
            if(response) {
                this.getPageData();
            }
        },

        async getPageData() {
            this.loading = true;
            try {
                let res = await axios.post('/v2/fabrics/overview', this.serverParams);
                this.pageData = res.data;
                this.loading = false;
                this.serverParams.refreshData = 0;
            }
            catch (error) {
                this.loading = false;
            }
        }
    }

}
</script>

<style lang="scss">
.dashboard{
    .scroll-div {
        .grid-body{
            height: 400px;
            width: 100%;
            overflow: scroll;
        }
        .table th {
            position: sticky;
            top: -1px;
        }
    }
    .flex {
        display: flex;
        width:100%;
        .grid{
            width: 100%;
            height: 100%;
        }
    }
    .loading{
        bottom: 0px;
        font-size: 150px;
        position: fixed;
        padding-top: 20%;
        top: 0px;
        text-align: center;
        width: 100%;
        left: 0px;
        right: 0px;
        background: #ffffffa8;
        color: #202529a3;
        z-index: 2;
    }
}
</style>
